import { render, staticRenderFns } from "./BalanceGeneral.vue?vue&type=template&id=7239feb8&scoped=true&"
import script from "./BalanceGeneral.vue?vue&type=script&lang=js&"
export * from "./BalanceGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7239feb8",
  null
  
)

export default component.exports